/* __next_internal_client_entry_do_not_use__ default auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { getDocument } from "@faire/web--source/common/globals/getDocument";
import * as React from "react";
import { useEffect, useRef } from "react";
/*
Synthetic click events created from a Facebook form are causing click outside to close the brand page sign up modal.
This checks targets the transient Facebook form to prevent it from triggering the onClickOutside.
*/ var isFacebookClickEvent = function(event) {
    var _event_target, _event_target_parentElement, _event_target1;
    return (event === null || event === void 0 ? void 0 : (_event_target = event.target) === null || _event_target === void 0 ? void 0 : _event_target.tagName) === "INPUT" && (event === null || event === void 0 ? void 0 : (_event_target1 = event.target) === null || _event_target1 === void 0 ? void 0 : (_event_target_parentElement = _event_target1.parentElement) === null || _event_target_parentElement === void 0 ? void 0 : _event_target_parentElement.action) === "https://www.facebook.com/tr/";
};
var ClickOutside = function(_param) {
    var onClickOutside = _param.onClickOutside, props = _object_without_properties(_param, [
        "onClickOutside"
    ]);
    var containerRef = useRef(null);
    useEffect(function() {
        var handle = function(event) {
            var el = containerRef.current;
            if (onClickOutside && el && event && !el.contains(event.target) && !isFacebookClickEvent(event)) {
                onClickOutside(event);
            }
        };
        if (onClickOutside) {
            var _getDocument;
            (_getDocument = getDocument()) === null || _getDocument === void 0 ? void 0 : _getDocument.addEventListener("click", handle, true);
        }
        return function() {
            var _getDocument;
            (_getDocument = getDocument()) === null || _getDocument === void 0 ? void 0 : _getDocument.removeEventListener("click", handle, true);
        };
    }, [
        onClickOutside
    ]);
    return /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({}, props), {
        ref: containerRef
    }));
};
export default ClickOutside;
